export const EmbeddedSections = [
  { legacyUrl: '/admin/vehicles', embeddedUrl: 'fleet' },
  { legacyUrl: '/admin/funds-to-render', embeddedUrl: 'funds-to-render' },
  { legacyUrl: '/admin/people-management', embeddedUrl: 'people-management' },
  { legacyUrl: '/admin/blog', embeddedUrl: 'blog' },
  { legacyUrl: '/admin/projects', embeddedUrl: 'projects' },
  { legacyUrl: '/admin/sales-v2', embeddedUrl: 'sales' },
  { legacyUrl: '/admin/boards-v2', embeddedUrl: 'tasks' },
  { legacyUrl: '/admin/induction', embeddedUrl: 'training' },
  { legacyUrl: '/admin/deviations', embeddedUrl: 'deviations' },
  { legacyUrl: '/admin/requisitions', embeddedUrl: 'purchase-orders/requisitions' },
  { legacyUrl: '/admin/providerArticles', embeddedUrl: 'purchase-orders/articles' },
  { legacyUrl: '/admin/training', embeddedUrl: 'training' },
  { legacyUrl: '/admin/documents', embeddedUrl: 'documents' },
  { legacyUrl: '/admin/users', embeddedUrl: 'users' },
  { legacyUrl: '/admin/purchase-orders', embeddedUrl: 'purchase-orders' },
  { legacyUrl: '/admin/change-log', embeddedUrl: 'ti-tasks' },
  { legacyUrl: '/admin/configurations', embeddedUrl: 'configurations' }
];

export const EmbeddedSectionsWithLegacyVersion = [
  { legacyUrl: '/admin/purchase-orders-legacy', embeddedUrl: '/admin/purchase-orders', section: 'purchase-orders' },
  { legacyUrl: '/admin/users-legacy', embeddedUrl: '/admin/users', section: 'users' },
];